import { Controller } from "@hotwired/stimulus"
import { createLogger } from "../lib/logger"
import { createI18nGetter } from "../lib/i18n_helper"

// Share Modal Controller - Manual Copy Modal Behavior
// Controls the manual copy modal rendered by Share::ManualCopyModalComponent
// I18n support via data-i18n-* attributes
const log = createLogger('ShareModal')

export default class extends Controller {
  static targets = ["input"]
  static values = { url: String }

  connect() {
    log.debug('connect')
    this.i18n = createI18nGetter(this)
    this.autoSelectInput()
  }

  // Auto-select input for easy manual copy
  autoSelectInput() {
    const focusDelay = window.BusinessConstants.UITiming.SHARE_INPUT_FOCUS_DELAY_MS
    setTimeout(() => {
      if (this.hasInputTarget) {
        this.inputTarget.select()
      }
    }, focusDelay)
  }

  // Copy button click handler
  async copy(event) {
    event.preventDefault()

    if (!this.hasInputTarget) return

    this.inputTarget.select()

    try {
      // Try modern Clipboard API
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(this.urlValue)

        // Update button text
        const button = event.currentTarget
        const originalText = button.textContent
        button.textContent = this.i18n('Copied', '連結已複製')

        // Auto-close modal
        const autoCloseDelay = window.BusinessConstants.UITiming.SHARE_MODAL_AUTO_CLOSE_MS
        setTimeout(() => this.close(), autoCloseDelay)
      } else {
        // Fallback: Input is already selected for manual copy
        log.debug('Clipboard API unavailable, input selected for manual copy')
      }
    } catch (error) {
      log.error('Clipboard write failed', error)
      // Input is already selected - user can manually copy
    }
  }

  // Close button click handler
  close(event) {
    if (event) event.preventDefault()
    this.element.remove()
  }

  // Click outside to close
  backdropClick(event) {
    if (event.target === this.element) {
      this.close()
    }
  }
}
